'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUppercase;

var _assertString = require('./util/assertString');

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUppercase(str) {
  (0, _assertString2.default)(str);
  return str === str.toUpperCase();
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/validator/lib/isUppercase.js
 ** module id = 3205
 ** module chunks = 0
 **/